import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FiltersModel, CustomerModel } from '@kanzi-apes/kanzi-models';
import moment from 'moment';

@Component({
    selector: 'lib-kanzi-sell-items-count',
    templateUrl: './kanzi-sell-items-count.component.html',
    styleUrls: ['./kanzi-sell-items-count.component.scss'],
    standalone: false
})
export class KanziSellItemsCountComponent implements OnInit, OnChanges {
  @Input() customer!: CustomerModel;

  sellType1: string = '';
  sellType2: string = '';
  description1: string = '';
  description2: string = '';
  path: string = '';
  filter1!: FiltersModel;
  filter2!: FiltersModel;
  monthName: string = '';
  today = Date.now();

  constructor() {}
  ngOnInit() {}
  ngOnChanges() {
    this.monthName = moment(new Date()).startOf('month').format('MMMM');
    this.sellType1 = 'primary';
    this.sellType2 = 'success';
    this.description1 = `Total ${this.monthName}`;
    this.description2 = 'Total';
    if (this.customer) {
      this.path = 'inventory/traces/';
      const minDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
      const maxDate = moment(new Date()).endOf('month').format('YYYY-MM-DD');
      this.filter1 = {
        customer_id: this.customer.id,
        page: 1,
        page_size: 1,
        action: 'SALE',
        created_min: minDate,
        created_max: maxDate,
      };
      this.filter2 = {
        customer_id: this.customer.id,
        page: 1,
        page_size: 1,
        action: 'SALE',
      };
    } else {
      this.path = 'inventory/traces/';
      const minDate = moment(new Date()).startOf('month').format('YYYY-MM-DD');
      const maxDate = moment(new Date()).endOf('month').format('YYYY-MM-DD');
      this.filter1 = {
        page: 1,
        page_size: 1,
        action: 'SALE',
        created_min: minDate,
        created_max: maxDate,
      };
      this.filter2 = {
        page: 1,
        page_size: 1,
        action: 'SALE',
      };
    }
  }
}
